function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.401 4.256l.042.692-.7-.084c-2.546-.325-4.77-1.427-6.659-3.277L1.161.669l-.238.678c-.503 1.511-.182 3.107.868 4.18.56.594.433.678-.532.325-.336-.113-.63-.198-.657-.155-.098.099.237 1.384.503 1.892.364.707 1.105 1.399 1.917 1.808l.685.325-.811.014c-.784 0-.812.014-.728.31.28.919 1.385 1.893 2.616 2.317l.868.297-.756.452a7.876 7.876 0 01-3.749 1.045c-.63.014-1.147.07-1.147.113 0 .141 1.707.932 2.7 1.243 2.98.918 6.52.522 9.177-1.046 1.889-1.115 3.777-3.333 4.659-5.48.475-1.143.951-3.234.951-4.236 0-.65.042-.735.825-1.512.462-.452.896-.946.98-1.087.14-.268.125-.268-.588-.028-1.189.423-1.357.367-.77-.269.434-.452.952-1.27.952-1.51 0-.043-.21.027-.448.154-.252.142-.811.354-1.23.48l-.756.24-.686-.465c-.377-.255-.91-.537-1.189-.622-.713-.198-1.804-.17-2.448.057-1.749.635-2.854 2.274-2.728 4.067z",
  fill: "currentColor"
});

var SvgTwitter = function SvgTwitter(props) {
  return React.createElement("svg", _extends({
    height: 16,
    width: 20,
    fill: "none"
  }, props), _ref);
};

export default SvgTwitter;